import React, { useEffect, useState } from "react";
import { FaSun, FaMoon } from "react-icons/fa"; // Import Icons
import "../styles/DarkModeToggle.css"; // Ensure styles are added

const DarkModeToggle = () => {
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem("theme") === "dark";
    });

    // Function to update meta theme color
    const updateThemeColor = (isDark) => {
        const metaThemeColor = document.querySelector("meta[name='theme-color']");
        if (metaThemeColor) {
            metaThemeColor.setAttribute("content", isDark ? "#121212" : "#f8f9fa"); // Dark mode & Light mode colors
        }
    };

    useEffect(() => {
        if (darkMode) {
            document.documentElement.setAttribute("data-theme", "dark");
            localStorage.setItem("theme", "dark");
            updateThemeColor(true);
        } else {
            document.documentElement.setAttribute("data-theme", "light");
            localStorage.setItem("theme", "light");
            updateThemeColor(false);
        }
    }, [darkMode]);

    return (
        <div className="dark-mode-container">
            <div className={`dark-mode-toggle ${darkMode ? "dark" : "light"}`} onClick={() => setDarkMode(!darkMode)}>
                <FaMoon className="icon moon-icon" />
                <div className="toggle-switch" />
                <FaSun className="icon sun-icon" />
            </div>
        </div>
    );
};

export default DarkModeToggle;
